import React from "react";
import useForm from "./index";
import Label from "./label";
import Tooltip from "@/components/tooltip";
import { TData, TForm, TInputElementProps, TInputProps } from "@/components/form/types";

export const RadioInput = ({ container, input, label, tooltip, className, hidden, options }: TInputElementProps<TRadioInput>) => {
    const click = (e: React.SyntheticEvent<HTMLDivElement>, id: string) => {
        const target = e.target as HTMLElement;
        if (target.tagName !== "DIV") return

        const element = document.getElementById(id);
        if (element) element.click();
    }

    if (hidden) {
        return null;
    }

    return (
        <div {...container} className={["sm-stretch", container?.className ?? className].join(" ")}>
            <Label {...label} tooltip={tooltip} options={options}/>
            <div className="group--flex gg-3" style={{ width: "100%" }}>
                { options?.data?.map?.((item: TData, index: number) => {
                    const { value, label, tooltip } = item;
                    const checked = Array.isArray(input.value) ? input.value.some(str => str === value) : input.value === value;
                    const required = !input.required ? false : input.required && !(Array.isArray(input.value) ? input.value.length > 0 : !!input.value);

                    return (
                        <div className="form__radio sm-flex--grow" key={index} onClick={(e) => click(e, input.id + index)}>
                            <input {...input} id={input.id + index} value={value} checked={checked} required={required}/>
                            <Label id={input.id + index} label={label} options={options} type="inline"/>
                            { tooltip && <Tooltip>{tooltip}</Tooltip> }
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

type TRadioInput = string | string[];
const useRadioInput = <T extends TRadioInput>(props: TInputProps<T>): TForm<TRadioInput> => {
    const form = useForm<TRadioInput>({
        id: "radio",
        type: "radio",
        default: "",
        ...props,
    })

    return {
        ...form,
    }
}

export default useRadioInput;
